const welcome = {
    title: 'به کنسول مدیریت خوش آمدید',
    description: 'کنسول مدیریت یک برنامه وب برای مدیریت JX Account بدون نیاز به کدنویسی است. ابتدا یک حساب ایجاد کنید. با این حساب می‌توانید JX Account را به‌صورت شخصی یا از طرف شرکت خود مدیریت کنید.',
    create_account: 'ایجاد حساب',
};
export default Object.freeze(welcome);
